import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { NAVBAR_TAB_NAMES } from "../const/navbarTabNames";

export const useGGRaveTabs = () => {
    const { t } = useTranslation()
    const location = useLocation()

    return {
        [NAVBAR_TAB_NAMES.cgrave_competitions]: {
            active: location?.pathname === '/awards',
            content: t("nav.cg_apply"),
            level: 2,
            linkTo: '/awards?sorting=5&tab=cgwave',
        },
        [NAVBAR_TAB_NAMES.cgrave_conference]: {
            content: t("nav.about_conference"),
            level: 2,
            linkTo: '/conference',
        },
        [NAVBAR_TAB_NAMES.cgrave_jury]: {
            content: t("nav.jury"),
            level: 2,
            linkTo: '/competition/0a375c53f2294df39b911b687d48d550/jury',
        },
    }
}import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { NAVBAR_TAB_NAMES } from "../const/navbarTabNames";

export const useGGRaveTabs = () => {
    const { t } = useTranslation()
    const location = useLocation()

    return {
        [NAVBAR_TAB_NAMES.cgrave_competitions]: {
            active: location?.pathname === '/awards',
            content: t("nav.cg_apply"),
            level: 2,
            linkTo: '/awards?sorting=5&tab=cgwave',
        },
        [NAVBAR_TAB_NAMES.cgrave_conference]: {
            content: t("nav.about_conference"),
            level: 2,
            linkTo: '/conference',
        },
        [NAVBAR_TAB_NAMES.cgrave_jury]: {
            content: t("nav.jury"),
            level: 2,
            linkTo: '/competition/0a375c53f2294df39b911b687d48d550/jury',
        },
    }
}